export default __webpack_public_path__ + "static/media/nft-defi.8e4d5c7b.svg";